import React from "react";
import Box from "@mui/material/Box";
import {IconButton, Typography} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {useTheme} from "../../../contexts/theme";


export interface CustomPaginationProps {
    page: number;
    onPageChange: (page: number) => void;
    disableArrowRight: boolean;
}

const CustomPagination = ({page, onPageChange, disableArrowRight} : CustomPaginationProps) => {
    const theme = useTheme();

    return <Box sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'end', // Centers the inner Box horizontally
        alignItems: 'center', // Centers the inner Box vertically if you want
        backgroundColor: theme.palette.blue,
        color: theme.palette.white,
        borderLeft: `2px solid ${theme.palette.white}`,
        borderRight: `2px solid ${theme.palette.white}`,
        borderBottom: `2px solid ${theme.palette.white}`,
        paddingBottom: theme.spacing.sm,
        paddingTop: theme.spacing.sm,
    }}>
        <Box sx={{
            display: 'flex',
            alignSelf: 'center',
            paddingRight: theme.spacing.md
        }}>
            {page > 0 && <IconButton size="small" onClick={() => onPageChange(page - 1)}>
                <ArrowBackIosNewIcon fontSize={'small'} sx={{color: theme.palette.white}}/>
            </IconButton>}
            <Typography variant="h6" sx={{color: theme.palette.white}}>
                {page + 1}
            </Typography>
            <Box
            width={'20px'}
            >
                {!disableArrowRight &&  <IconButton size="small" onClick={() => {onPageChange(page + 1)}}>
                    <ArrowForwardIosIcon fontSize={'small'} sx={{color: theme.palette.white}}/>
                </IconButton>}
            </Box>

        </Box>
    </Box>
}

export default CustomPagination;